import { render, staticRenderFns } from "./UniversitySearchFilter.vue?vue&type=template&id=76214d40"
import script from "./UniversitySearchFilter.vue?vue&type=script&lang=js"
export * from "./UniversitySearchFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports